import api from "./client";

import type { ApiResponse, Paginated } from "#/types/api";
import type { ChangePasswordRequest } from "#/types/auth";
import type { BulkCreateUsersPayload, User, UserQueryParams } from "#/types/user";

export const usersApi = {
  bulkCreate: (body: BulkCreateUsersPayload): Promise<ApiResponse<User[]>> =>
    api.post("/user/bulk", body),
  getAll: (params: UserQueryParams): Promise<ApiResponse<Paginated<User[]>>> =>
    api.get("/user", { params }),
  update: (
    id: string,
    body: Partial<User>
  ): Promise<ApiResponse<User>> => api.patch(`/user/${id}`, body),
  changePassword: (
    id: string,
    body: ChangePasswordRequest
  ): Promise<ApiResponse<User>> => api.patch(`/user/${id}`, body),
  delete: (id: string): Promise<ApiResponse<User>> => api.delete(`/user/${id}`),
};
